import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { SectionCta } from "../SectionCta";
import { faqs } from "../../data/faqs";
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-cream px-4 py-16 sm:px-5 sm:py-24" data-id="element-163" data-mp="uq9dpp9z694v">
      <div className="mx-auto max-w-3xl" data-id="element-164" data-mp="ut5c1epqiztu">
        <h2 className="text-center font-serif text-[28px] font-black leading-tight text-navy sm:text-4xl" data-id="element-165" data-mp="729m6n4uaep8">
          Frequently Asked Questions
        </h2>

        <ul className="mt-10 space-y-3" data-id="element-166" data-mp="gzebgvtzeqa9">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          const panelId = `faq-panel-${i}`;
          return <li key={f.question} className="overflow-hidden rounded-2xl bg-white ring-1 ring-navy/10" data-id="element-167" data-mp="c2e6ypcs5vl9" data-mpi={i}>
                <button type="button" aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-wine" data-id="element-168" data-mp="1sge1fksuwt14">
                  <span className="text-base font-bold text-navy sm:text-lg" data-id="element-169" data-mp="rq2el0fs5e8z">{f.question}</span>
                  <PlusIcon className={`h-5 w-5 shrink-0 text-wine transition-transform duration-200 ease-out ${isOpen ? "rotate-45" : ""}`} aria-hidden="true" data-id="element-170" data-mp="vr5vzrdh7icb" />
                </button>
                <AnimatePresence initial={false} data-id="element-171" data-mp="81tfs7jqea0i">
                  {isOpen && <motion.div id={panelId} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-172" data-mp="cw7gmph5x9ck">
                      <p className="px-5 pb-5 text-[15px] leading-relaxed text-muted" data-id="element-173" data-mp="iqfpasq7c4xv">{f.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>

        <SectionCta label="Yes! I'm ready to get started" data-id="element-174" data-mp="shadi2n0dely" />
      </div>
    </section>;
}